import { pendingEditProfileListState } from '../state/pendingEditProfileListState'
import {
    Fetch_All_Region_Data1,FETCH_PENDING_EDITPROFILE_REQUEST, FETCH_PENDING_EDITPROFILE_SUCCESS, FETCH_PENDING_EDITPROFILE_ERROR,
    UPDATE_PENDING_EDITPROFILE_REQUEST, UPDATE_PENDING_EDITPROFILE_SUCCESS, UPDATE_PENDING_EDITPROFILE_ERROR
} from '../actions/pendingEditProfileListAction'

var initialStatusCode=''

export function pendingEditProfileReducer(state = pendingEditProfileListState, action) {
    switch (action.type) {
        case FETCH_PENDING_EDITPROFILE_REQUEST:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                statusCode:initialStatusCode,
                errorMessage:''
            })
        case FETCH_PENDING_EDITPROFILE_SUCCESS:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                pendingEditProfileList: action.pendingEditProfileList,
                statusCode : action.statusCode
            })
        case FETCH_PENDING_EDITPROFILE_ERROR:
            return Object.assign({}, state, {
                errorNumber: action.errorNumber,
                errorMessage: action.errorMessage
            })
        case UPDATE_PENDING_EDITPROFILE_REQUEST:
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                statusCode:initialStatusCode,
                errorMessage :''
            })
        case UPDATE_PENDING_EDITPROFILE_SUCCESS:
            
            return Object.assign({}, state, {
                isLoading: action.isLoading,
                pendingEditProfileList: action.pendingEditProfileList,
                errorMessage: action.messageLabel,
                statusCode: action.statusCode,
            })
        case UPDATE_PENDING_EDITPROFILE_ERROR:
            return Object.assign({}, state, {
                errorNumber: action.errorNumber,
                errorMessage: action.messageLabel
            })
             case Fetch_All_Region_Data1:
                                            return Object.assign({}, state, {
                                                errorCode : action.errorCode,
                                                statusCode : action.statusCode,
                                                regionList : action.regionList
                                            })
        default:
            return state;
    }
}
